import { render, staticRenderFns } from "./BoardSettingsImport.vue?vue&type=template&id=181ddbe4&scoped=true&lang=pug&"
import script from "./BoardSettingsImport.vue?vue&type=script&lang=js&"
export * from "./BoardSettingsImport.vue?vue&type=script&lang=js&"
import style0 from "./BoardSettingsImport.vue?vue&type=style&index=0&id=181ddbe4&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181ddbe4",
  null
  
)

export default component.exports